import { add } from './add';
import { findAll } from './findAll';
import { findById } from './findById';
import { findByHosts } from './findByHosts';
import { remove } from './remove';
import { update } from './update';

export const hostGroupAPI = {
  add,
  findAll,
  findById,
  findByHosts,
  remove,
  update,
};
